import { COUNTRY_CODE } from "consts";

export type RegionResponse = {
  regions: { [key in COUNTRY_CODE]: string };
};

export type RegionNamesResponse = {
  regions: string[];
};

// For countries with grouped regions (eg: GB for now)
export type GroupedRegion = {
  country: string;
  regions: string[];
};

export type GroupedRegionNamesResponse = {
  groupedRegions: Record<string, string[]>;
};

export type RegionApiResponse = RegionNamesResponse | GroupedRegionNamesResponse;

// Type guard to check if response has grouped regions
export const hasGroupedRegions = (response: RegionApiResponse): response is GroupedRegionNamesResponse =>
  "groupedRegions" in response && typeof response.groupedRegions === "object" && !Array.isArray(response.groupedRegions);
